/**
 * Central list of SignalR event names used by the front end.
 * Matches PostalBridge.SignalR.Hubs.SignalRHubEventNames in the back end.
 */
export class SignalRHubEventNames {
    /** Fired by the hub when a batch of incoming‑mail images finishes processing */
    static readonly IncomingMailBatchProcessingComplete =
      'IncomingMailBatchProcessingComplete' as const;

    /** Fired when the mail queue changes (e.g. new mail arrives) */
    static readonly MailQueueUpdated =
      'MailQueueUpdated' as const;

    /** Fired when a CMRA/CRD pull-contacts job completes successfully */
    static readonly CmraPullContactsCompleted =
      'CmraPullContactsCompleted' as const;

    /** Fired when a CMRA/CRD pull-contacts job fails */
    static readonly CmraPullContactsFailed =
      'CmraPullContactsFailed' as const;
  }
  
  /* Example usage:
  
  this.hubConnection.on(
    SignalRHubEventNames.IncomingMailBatchProcessingComplete,
    () => {
      // refresh grid, notify user, etc.
    }
  );
  
  */
  